<script setup>

</script>

<template>
    <div class="w-20 h-20 border-l-4 border-blue-600 rounded-full animate-spin"/>
</template>

<style scoped>

</style>
